export const Shape1 = () => {
  return (
    <svg
      viewBox="0 0 395 389"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M160.553 8.82308C183.479 -2.94058 210.668 -2.94057 233.595 8.82309L278.167 31.6929L323.837 52.2813C347.329 62.8715 364.281 84.129 369.378 109.388L379.288 158.495L391.666 207.038C398.033 232.007 391.983 258.515 375.413 278.249L343.198 316.614L312.963 356.558C297.411 377.104 272.914 388.901 247.154 388.25L197.074 386.984L146.993 388.25C121.233 388.901 96.7363 377.104 81.1843 356.558L50.9494 316.614L18.7349 278.249C2.16451 258.515 -3.88567 232.007 2.48142 207.038L14.8597 158.495L24.7693 109.388C29.8666 84.129 46.8189 62.8715 70.3105 52.2813L115.981 31.6929L160.553 8.82308Z" />
    </svg>
  );
};
